import store from "@/store/index";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { SET_PORTAL_MODE } from "@/store/mutations/user";
import {
  clearSessionTimer,
  refreshSessionWithServer,
  resetSessionTimer,
} from "./session_timeout";

function isSessionUnauthorized(error) {
  const responseError = error?.response;
  if (!responseError) {
    return false;
  }
  return (
    responseError.status === 401 &&
    responseError.data?.message === "Unauthenticated."
  );
}

export function clearLocalAuthSession() {
  store.commit(AUTH_LOGOUT);
  store.commit(SET_PORTAL_MODE, null);
  clearSessionTimer();
}

export async function validateStoredSession() {
  if (!store.getters.isAuthenticated) {
    return true;
  }
  try {
    await refreshSessionWithServer();
    return true;
  } catch (error) {
    if (isSessionUnauthorized(error)) {
      clearLocalAuthSession();
      return false;
    }
    resetSessionTimer();
    return true;
  }
}
